module.exports = "<div baCardBlur class=\"animated fadeIn card {{cardType}} {{baCardClass || ''}}\" zoom-in>\r\n    <div *ngIf=\"title\" class=\"card-header clearfix\">\r\n        <h3 class=\"card-title\">{{title}}</h3>\r\n    </div>\r\n    <div class=\"card-body\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiCard/ubiCard.html
// module id = ../../../../../src/app/theme/components/ubiCard/ubiCard.html
// module chunks = main